'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Tab = require('./Tab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Tabs = function (_a) {
    var children = _a.children;
    var _b = React__default['default'].useState(children[0].props.label), activeTab = _b[0], setActiveTab = _b[1];
    var scrollRef = React__default['default'].useRef();
    var onClickTabItem = function (tab) {
        setActiveTab(tab);
    };
    var arrowClickHandler = function (position) {
        var currentPosition = scrollRef.current.scrollLeft;
        position === 'right'
            ? scrollRef.current.scrollTo({ top: 0, left: currentPosition + 25, behaviour: 'smooth' })
            : scrollRef.current.scrollTo({ top: 0, left: currentPosition - 25, behaviour: 'smooth' });
    };
    return (React__default['default'].createElement("div", { className: "lp__tabs--wrapper" },
        React__default['default'].createElement("ol", { className: "lp__tab--list" },
            React__default['default'].createElement("div", { className: "lp__tabs--arrow left__arrow", onClick: function () { return arrowClickHandler('left'); } }, "<"),
            React__default['default'].createElement("div", { className: "lp__tab--group", ref: scrollRef }, children.map(function (child) {
                var label = child.props.label;
                return (React__default['default'].createElement(Tab.Tab, { activeTab: activeTab, key: label, label: label, onClick: onClickTabItem }));
            })),
            React__default['default'].createElement("div", { className: "lp__tabs--arrow right__arrow", onClick: function () { return arrowClickHandler('right'); } }, ">")),
        React__default['default'].createElement("div", { className: "lp__tab--content" }, children.map(function (child) {
            if (child.props.label !== activeTab)
                return undefined;
            return child.props.children;
        }))));
};

exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map
